export default __webpack_public_path__ + "static/media/ashley.baadb68d.jpg";